// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#mesures-plugin[data-v-4045b620]{pointer-events:auto}@container (max-width: 600px ){#mesures-plugin{display:none}}", ""]);
// Exports
module.exports = exports;
